import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import SupportForm from "./SupportForm";

interface CreateSupportModalDialogButtonProps {
  onCreated?: (id: string) => void;
}

const CreateSupportModalDialogButton: FC<CreateSupportModalDialogButtonProps> = ({ onCreated }) => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.supports.new}>
          <SupportForm onClose={() => setShowNewItemDialog(false)} onCreated={onCreated} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateSupportModalDialogButton;
